<template>
  <SimpleLink
    v-if="isClickable"
    :to="link"
    class="btn"
  >
    <p class="text-sm font-base">
      {{ title }}
    </p>
  </SimpleLink>
  <p
    v-else
    class="text-sm font-base"
  >
    {{ title }}
  </p>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ProductCardVerticalTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    isClickable: {
      type: Boolean,
      default: true,
    },
  },
});

</script>
